import { Button, Col, Flex, Modal, Row, Space } from "antd";
import { useTranslation } from "react-i18next";
import WorkinStatus from "../TagCustom/WorkinStatus";
import TableAntd from "../Table";
import { render } from "@testing-library/react";
import dayjs from "dayjs";

function ModalWorkinClockingIn({
    isLoading = false,
    isModalClockingOpen,
    setIsModalClockingOpen,
    work = [],
    title = {}
}) {

    function formatTime(dateString) {
        if (!dateString) return;

        const formattedString = dateString.replace(/(\.\d{1,2})$/, (match) => match.padEnd(4, "0"));

        const format = formattedString.length > 8 ? "HH:mm:ss.SSS" : "HH:mm:ss";

        const date = dayjs(formattedString, format);

        return date.isValid() ? date.format(i18n.language === "en" ? "HH:mm" : "HH:mm น.") : "-";
    }
    function convertMinuteToTimeFormat(minutes) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        const formattedMinutes = String(remainingMinutes).padStart(2, '0');

        // If hours is 0, return only the minutes
        if (hours === 0) {
            if (remainingMinutes < 1) {
                return i18n.language === 'en' ? "0 minutes" : "0 นาที";
            } else {
                return i18n.language === 'en' ? `${formattedMinutes} minutes` : `${formattedMinutes} นาที`;
            }
        } else {

            // Format hours to always have two digits
            const formattedHours = String(hours).padStart(2, '0');
            // Return the formatted time
            return i18n.language === 'en' ? `${formattedHours} hour ${formattedMinutes} minutes` : `${formattedHours} ชั่วโมง ${formattedMinutes} นาที`;

        }

    }

    console.log("work", title)
    const { t, i18n } = useTranslation();
    // const mockstatus = [
    //     {
    //         name: "ปกติ",
    //         nameEn: "Normal"
    //     },
    //     {
    //         name: "ขาดงาน",
    //         nameEn: "Absent"
    //     }
    // ]

    // const mocktable = [
    //     {
    //         period: "01",
    //         shift: "ปกติ",
    //         shiftEn: "Normal",
    //     }
    // ]

    const column = [
        {
            title: <div className="text-table">{t('workin.period')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: "150px",
            render: (_, record, index) => {
                return <span
                    style={{
                        color: "#313131",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                    }}
                >
                    {index + 1}
                </span>;
            },
        },

        {
            title: <div className="text-table">{t('shift.label.status')}</div>,
            dataIndex: "workingStatus",
            key: "workingStatus",
            align: "center",
            width: "150px",
            render: (_, record) => {
                return <WorkinStatus value={i18n.language === "en" ? record?.statusEn : record?.status} />
            }
        },
        {
            title: <div className="text-table">{t('workin.time-in')}</div>,
            dataIndex: "startTime",
            key: "startTime",
            align: "center",
            width: "150px",
            render: (_, record) => {
                return record?.startTime ? formatTime(record?.startTime) : "-"
            }
        },
        {
            title: <div className="text-table">{t('workin.time_out')}</div>,
            dataIndex: "endTime",
            key: "endTime",
            align: "center",
            width: "150px",
            render: (_, record) => {
                return record?.endTime ? formatTime(record?.endTime) : "-"
            }
        },
        {
            title: <div className="text-table">{t('workin.work-time')}</div>,
            dataIndex: "workTime",
            key: "workTime",
            align: "center",
            width: "250px",
            render: (_, record) => {
                return record?.workTime ? convertMinuteToTimeFormat(record?.workTime) : "-"
            }
        },
    ]
    return (
        <Modal title={t("report.label.clocking_in_history")}
            open={isModalClockingOpen}
            maskClosable={false}
            footer={false}
            onCancel={() => setIsModalClockingOpen(false)}
            width={"50vw"}
        >
            <Space direction="vertical" style={{ width: "100%" }} size={24}>
                <Flex vertical gap={8}>
                    <Flex gap={8}>

                        <WorkinStatus
                            value={i18n.language === "en" ? title.statusEn : title.status}
                        />

                    </Flex>

                    <Flex>
                        <Row style={{ width: "100%" }}>
                            <Col span={6}>
                                <span style={{ color: "#42526D" }}>
                                    {t("workin.label.day_mont_year")}
                                </span>
                            </Col>
                            <Col span={18}>
                                <span style={{ color: "#42526D", fontWeight: "bold" }}>
                                    {dayjs(title?.date).format(i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")}
                                </span>
                            </Col>
                            <Col span={6}>
                                <span style={{ color: "#42526D" }}>
                                    {t("shift.header")}
                                </span>
                            </Col>
                            <Col span={18}>
                                <span style={{ color: "#42526D", fontWeight: "bold" }}>
                                    {i18n.language === "en" ? title?.shiftNameEn : title?.shiftNameEn ?? "-"}
                                </span>
                            </Col>
                            <Col span={6}>
                                <span style={{ color: "#42526D" }}>
                                    {t("shift.label.ship_periods")}
                                </span>
                            </Col>
                            <Col span={18}>
                                <span style={{ color: "#42526D", fontWeight: "bold" }}>
                                    {title?.workInDateStart ?? "-"} ถึง {title?.workInDateEnd ?? "-"}
                                </span>
                            </Col>
                        </Row>
                    </Flex>
                </Flex>

                <TableAntd
                    loading={isLoading}
                    columns={column}
                    dataSource={work}
                />
            </Space>
        </Modal>
    )
}

export default ModalWorkinClockingIn;